<template>
  <div>
    <v-btn color="primary" @click="dialog = true">Extender pantalla</v-btn>

    <!-- UNA sola instancia -->
    <DashboardNyx :show-filters="!dialog" :fullscreen="dialog" @close="dialog = false" />

    <!-- Oscurecer fondo cuando está en fullscreen -->
    <v-overlay :value="dialog" opacity="0.6" :z-index="2000" />
  </div>
</template>

<script>
import DashboardNyx from '../Reportes/DashboardAgrupado/DashboardNyx.vue';

export default {
  components: {
    DashboardNyx,
  },
  data() {
    return {
      dialog: false,
    }
  }
}
</script>